import { z } from "zod";

export const ProductTemplateSchema = z.object({
  id: z.number(),
  name: z.string(),
  value: z.string(),
  type: z.number(),
  plain: z.boolean(),
  options: z.string(),
  isDefaultForType: z.boolean(),
  isDisallowPrintToPdf: z.boolean(),
  readOnly: z.boolean(),
  description: z.string(),
  priority: z.number(),
  customCss: z.string(),
  pdfPrefix: z.string(),
  language: z.null(),
});

export type ProductTemplate = z.infer<typeof ProductTemplateSchema>;
